<template>
  <div id="termItemModal" class="menu-builder__item-modal modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Term item</h4>
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label for="termItemName">Name *</label>
              </div>
              <div class="col-8">
                <input
                  id="termItemName"
                  v-model="entity.name"
                  type="text"
                  class="form-control"
                  data-validation="true"
                >
              </div>
            </div>
          </div>

          <div class="menu-builder__item-modal-error" style="color: red">{{ errorMessage }}</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary save-btn" @click="saveChanges">
            Save changes
            <span class="btn-loader" style="display: none;" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'ModalTermItem',

  data() {
    return {
      entity: {
        id: null,
        weight: null,
        parent_id: null,
        vocabulary_id: null,
        name: null,
      },
      spot: null,
      action: 'new',
      errorMessage: '',
    };
  },

  mounted() {
    $(this.$el).find('input[data-validation="true"]').change(function () {
      $(this).parents('.form-group').removeClass('error');
    });

    this.$root.$on('termItemSetParams', (content, action) => {
      this.entity.id = content.id;
      this.entity.parent_id = content.parent_id;
      this.entity.weight = content.weight;
      this.entity.name = content.name;
      this.entity.vocabulary_id = content.vocabulary_id;

      this.spot = content.spot;
      this.action = action;

      $(this.$el).modal('show');
    });

    $(this.$el).on('hidden.bs.modal', () => {
      this.entity.id = null;
      this.entity.parent_id = null;
      this.entity.weight = null;
      this.entity.name = null;
      this.entity.vocabulary_id = null;

      this.spot = null;

      this.errorMessage = '';
    });
  },

  destroyed() {
    $('.modal-backdrop').remove();
    this.$root.$off('termItemSetParams');
  },

  methods: {
    formIsValide() {
      if (!this.entity.name) {
        this.errorMessage = 'Field title is required';
        return false;
      }
      return true;
    },
    saveChanges() {
      if (!this.formIsValide()) return;
      if (this.action === 'new') {
        this.saveNew();
      } else if (this.action === 'edit') {
        this.saveExisting();
      }
    },
    saveExisting() {
      this.errorMessage = '';
      $(this.$el).find('.btn-loader').show();
      const postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      postFormData.append('weight', this.entity.weight);
      postFormData.append('vid', this.entity.vocabulary_id);
      if (this.entity.parent_id) postFormData.append('parent_id', this.entity.parent_id);

      this.$apiHttp.post(`${this.$config.app_api.prefix}terms/${this.entity.id}`, postFormData)
        .then(() => {
          this.$root.$emit('termItemSaveExistingSuccess', this.entity);
          $(this.$el).find('.btn-loader').hide();
          $(this.$el).modal('hide');
        })
        .catch((error) => {
          $(this.$el).find('.btn-loader').hide();
          this.errorMessage = 'Changes did not saved. There are some problems with server.';
          console.error(error);
        });
    },
    saveNew() {
      const postFormData = new FormData();
      this.errorMessage = '';
      $(this.$el).find('.btn-loader').show();
      postFormData.append('name', this.entity.name);
      postFormData.append('weight', this.entity.weight);
      postFormData.append('vid', this.entity.vocabulary_id);
      if (this.entity.parent_id) postFormData.append('parent_id', this.entity.parent_id);

      this.$apiHttp.post(`${this.$config.app_api.prefix}terms`, postFormData)
        .then((response) => {
          this.entity.id = response.data.id;
          const newContent = _.cloneDeep(this.entity);
          const newSpot = this.spot;
          newContent.url = response.data.url;
          this.$root.$emit('termItemSaveNewSuccess', newContent, newSpot);
          $(this.$el).find('.btn-loader').hide();
          $(this.$el).modal('hide');
        })
        .catch((error) => {
          $(this.$el).find('.btn-loader').hide();
          this.errorMessage = 'Item did not created. There are some problems with server.';
          console.error(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// TermItem.vue?2d11bca4